import forge from "node-forge"

import * as Sentry from "@sentry/react"

import axios from "axios"

const requests = axios.create({
  baseURL: import.meta.env.VITE_BACKEND_URL,
  withCredentials: true,
})

const encrypt = (data: string) => {
  const publicKey = forge.pki.publicKeyFromPem(import.meta.env.VITE_PUBLIC_KEY)
  const encrypted = publicKey.encrypt(data, "RSA-OAEP", {
    md: forge.md.sha256.create(),
    mgf1: {
      md: forge.md.sha256.create(),
    },
  })
  return forge.util.encode64(encrypted)
}
requests.interceptors.request.use(
  request => {
    if (request.data) {
      request.data = {
        encrypteddata: encrypt(JSON.stringify(request.data)),
        unencrypteddata: import.meta.env.DEV ? request.data : undefined,
      }
    }
    return request
  },
  error => {
    return Promise.reject(error)
  }
)

requests.interceptors.response.use(
  response => {
    return response
  },
  error => {
    Sentry.captureException(error)

    if (error.response && error.response.status === 401) {
      if (!window.location.href.endsWith("/auth/login")) {
        requests.post<Response>("/logout", {}).finally(() => {
          const token = localStorage.getItem("token")
          if (token) {
            localStorage.setItem("expired-session", "true")
            localStorage.removeItem("token")
          }
          window.location.href = "/auth/login"
        })
      }
    }
    return Promise.reject(error)
  }
)

export default requests
